import { SVGProps } from "react"

const ListBranches = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={14}
    fill="none"
    {...props}
  >
    <g fill="#fff" clipPath="url(#a)">
      <path d="M14.8 3.5c-1.917-.06-1.917-2.839 0-2.9 1.916.061 1.915 2.84 0 2.9Zm0-2.328a.879.879 0 0 0 0 1.757.879.879 0 0 0 0-1.757ZM.536 1.766h11.062a.286.286 0 0 1 0 .571H.536a.286.286 0 0 1 0-.571ZM14.8 8.45c-1.918-.06-1.917-2.84 0-2.9 1.915.06 1.915 2.84 0 2.9Zm0-2.329a.879.879 0 0 0 0 1.758.879.879 0 0 0 0-1.758ZM.536 6.714h11.062a.286.286 0 0 1 0 .571H.536a.286.286 0 0 1 0-.571ZM14.8 13.398c-1.917-.06-1.917-2.84 0-2.9 1.916.06 1.915 2.84 0 2.9Zm0-2.329a.88.88 0 0 0 0 1.758.88.88 0 0 0 0-1.758ZM.536 11.663h11.062a.286.286 0 0 1 0 .572H.536a.286.286 0 0 1 0-.572Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M16.25.571h-16v12.857h16z" />
      </clipPath>
    </defs>
  </svg>
)
export default ListBranches
